import { render, staticRenderFns } from "./ReturnHistoryList.vue?vue&type=template&id=98d68168&scoped=true&"
import script from "./ReturnHistoryList.vue?vue&type=script&lang=js&"
export * from "./ReturnHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnHistoryList.vue?vue&type=style&index=0&id=98d68168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d68168",
  null
  
)

export default component.exports